import React from 'react';
import { Link } from "react-router-dom";
import cover from '../../images/profile.png'
import './Header.css'
const Header = () => {

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <div className="container-fluid">
                    <Link className="navbar-brand text-light logoControls" to="/"><img src={cover} alt="" /></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon toggle"></span>     
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item">
                                <Link className="nav-link active text-light" aria-current="page" to="/home">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-light" to="/AboutDetail">About</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-light" to="/project">Project</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-light" to="/blog">Blog</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-light" to="/contact">Contact</Link>
                            </li>
                            <li className="nav-item">
                                <a className="text-decoration-none btn btn-info" target="_blank" rel="noopener noreferrer" href="https://drive.google.com/uc?export=download&id=1fkdVKep7A3FyYddBstHmC3VjKIUxuoMf">Resume</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Header;